import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { BUTTON, Button } from 'components/common/Button/Button';
import styles from './GroupPermissionsSelector.scss';

const ConfirmChangeDialog = ({
    open,
    onCancel,
    onConfirm,
    title,
    content,
    confirmText = 'Confirm Change',
    cancelText = 'Cancel',
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <div className={styles.confirmDialog} data-cy="ConfirmChangeDialog">
                <IconButton aria-label="close" className={styles.closeButton} onClick={onCancel} data-cy="ConfirmChangeDialog-onCancel">
                    <CloseIcon />
                </IconButton>
                <div>
                    <Typography variant="h6" data-cy="ConfirmChangeDialog-h6">{title}</Typography>
                </div>
                <DialogContent
                    classes={{
                        root: styles.content,
                    }}
                >
                    {content}
                </DialogContent>
                <div className={styles.buttons}>
                    <Button
                        className={styles.btnOutline}
                        onClick={onCancel}
                        bgcolor={BUTTON.BGCOLOR.CLEAR}
                        color={BUTTON.COLOR.GREY}
                        data-cy="ConfirmChangeDialog-onClick"
                    >
                        {cancelText}
                    </Button>
                    <Button onClick={onConfirm} bgcolor={BUTTON.BGCOLOR.ORANGE} color={BUTTON.COLOR.WHITE} data-cy="ConfirmChangeDialog-onConfirm">
                        {confirmText}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmChangeDialog;
